import React from 'react'

import { getTranslate } from '../../utilities/i18n'
import ButtonWithQueryForwarding from '../button/ButtonWithQueryForwarding'
import Icon from '../icons/Icon'

type Props = {
  readonly link?: string
  readonly iconName: string
  readonly children: React.ReactNode
  readonly title: string
  readonly subtitle: string
}

const ContentSection: React.FC<Props> = ({ link, iconName, children, title, subtitle }) => {
  const { t } = getTranslate()

  return (
    <div className="py-12">
      <div className="mb-5 flex items-center">
        <Icon className="mr-4" icon={iconName} size="slg" color="primary" />
        <div>
          <h2 className="text-2xl text-petrol-500">{title}</h2>
          <div className="-mt-2 text-base text-text-color">{subtitle}</div>
        </div>
      </div>
      {children}
      {link && (
        <div className={`flex justify-center`}>
          <ButtonWithQueryForwarding href={link} className="mt-4 tablet:mt-8">
            {t('component.premiumContent.showAll')}
          </ButtonWithQueryForwarding>
        </div>
      )}
    </div>
  )
}

export default ContentSection
